require('./bootstrap');

// Slick
require('slick-carousel/slick/slick.min')

require('aos')
